export default "__VITE_ASSET__Dv$jUHOJ__"